import { useState } from 'react'
import { useParams } from 'react-router-dom'

import { ReactComponent as Logo } from 'shared/assets/icons/logo-admin.svg'
import NewPageModal from 'shared/components/PageList/components/modals/NewPageModal'
import Tools from 'shared/components/PageListTools'
import LogoContainerLink from 'shared/layout/Default/components/Header/components/LogoContainerLink'
import { LiveUser } from 'shared/types/global'
import Flex from 'shared/ui/Flex'
import HeaderGoBackButton from 'shared/ui/HeaderGoBackButton'
import LiveAvatarsRow from 'shared/ui/LiveAvatarsRow'
import ViewModeSwitch from 'shared/ui/ViewModeSwitch'

type HeaderProps = {
  liveUsers: LiveUser[]
  currentView: 'content' | 'cover'
  onViewSwitch: (view: 'content' | 'cover') => void
}

const AdminProjectCoverHeader: React.FC<HeaderProps> = ({
  liveUsers,
  currentView,
  onViewSwitch
}) => {
  const { groupId, projectId } = useParams()
  const [isNewPageModalOpen, setIsNewPageModalOpen] = useState(false)

  const handleViewChange = (view: string) => {
    if (view === 'Cover') {
      onViewSwitch('cover')
    } else if (view === 'Content') {
      onViewSwitch('content')
    }
  }

  return (
    <Flex justifyContent="space-between">
      <Flex columnGap={16}>
        <HeaderGoBackButton />
        <LogoContainerLink to="/admin/projects">
          <Logo />
        </LogoContainerLink>
      </Flex>

      <ViewModeSwitch
        isDisabled={false}
        initialActiveIndex={currentView === 'cover' ? 0 : 1}
        options={['Cover', 'Content']}
        onChange={handleViewChange}
      />

      <Flex alignItems="center" columnGap={48}>
        <LiveAvatarsRow liveUsers={liveUsers || []} />

        <Tools
          openModal={() => setIsNewPageModalOpen(true)}
          settingsPath={`/admin/projects/${groupId}/${projectId}/settings`}
        />
      </Flex>

      <NewPageModal
        groupId={groupId!}
        projectId={projectId!}
        isOpen={isNewPageModalOpen}
        closeModal={() => setIsNewPageModalOpen(false)}
      />
    </Flex>
  )
}

export default AdminProjectCoverHeader
